/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { ParticipantRole } from './ParticipantRole.js';
import {
    ParticipantRoleFromJSON,
    ParticipantRoleFromJSONTyped,
    ParticipantRoleToJSON,
} from './ParticipantRole.js';

/**
 * 
 * @export
 * @interface SearchSentencesRequest
 */
export interface SearchSentencesRequest {
    /**
     * 
     * @type {string}
     * @memberof SearchSentencesRequest
     */
    text?: string;
    /**
     * 
     * @type {number}
     * @memberof SearchSentencesRequest
     */
    threshold?: number;
    /**
     * 
     * @type {ParticipantRole}
     * @memberof SearchSentencesRequest
     */
    participantRole?: ParticipantRole;
}

/**
 * Check if a given object implements the SearchSentencesRequest interface.
 */
export function instanceOfSearchSentencesRequest(value: object): boolean {
    return true;
}

export function SearchSentencesRequestFromJSON(json: any): SearchSentencesRequest {
    return SearchSentencesRequestFromJSONTyped(json, false);
}

export function SearchSentencesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchSentencesRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'text': json['text'] == null ? undefined : json['text'],
        'threshold': json['threshold'] == null ? undefined : json['threshold'],
        'participantRole': json['participantRole'] == null ? undefined : ParticipantRoleFromJSON(json['participantRole']),
    };
}

export function SearchSentencesRequestToJSON(value?: SearchSentencesRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'text': value['text'],
        'threshold': value['threshold'],
        'participantRole': ParticipantRoleToJSON(value['participantRole']),
    };
}

